/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_Water_TitleInputs */

const en_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You preserved ${i?.number} L of water!`)
};

const ar_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`لقد حافظت على ${i?.number} لتر من الماء!`)
};

const de_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast ${i?.number} L Wasser gespart!`)
};

const es_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Has ayudado a preservar ${i?.number} L de agua!`)
};

const fr_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez préservé ${i?.number} L d'eau !`)
};

const it_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai preservato ${i?.number} L di acqua!`)
};

const ja_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}Lの水を節約しました！`)
};

const ko_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}L의 물을 절약했어요!`)
};

const pt_br_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você preservou ${i?.number} L de água!`)
};

const ru_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы сохранили ${i?.number} л воды!`)
};

const th_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณได้อนุรักษ์น้ำ ${i?.number} ล.!`)
};

const tr_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} L su tasarruf ettin!`)
};

const zh_cn_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你帮地球守住了 ${i?.number} 公升的水资源`)
};

const zh_tw_earth_day_2025_impact_water_title = /** @type {(inputs: Earth_Day_2025_Impact_Water_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你幫地球守住了 ${i?.number} 公升的水資源`)
};

/**
* | output |
* | --- |
* | "You preserved {number} L of water!" |
*
* @param {Earth_Day_2025_Impact_Water_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_water_title = /** @type {((inputs: Earth_Day_2025_Impact_Water_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Water_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_water_title(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_water_title(inputs)
	if (locale === "de") return de_earth_day_2025_impact_water_title(inputs)
	if (locale === "es") return es_earth_day_2025_impact_water_title(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_water_title(inputs)
	if (locale === "it") return it_earth_day_2025_impact_water_title(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_water_title(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_water_title(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_water_title(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_water_title(inputs)
	if (locale === "th") return th_earth_day_2025_impact_water_title(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_water_title(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_water_title(inputs)
	return zh_tw_earth_day_2025_impact_water_title(inputs)
});